import { VideoPlaylist } from '@/components/VideoPlaylist';
import { VideoReelsTheme } from '@/components/VideoReels/theme';
import { GenericSlot } from 'base/components/GenericSlot';

export const VideoReels = GenericSlot({ as: VideoPlaylist, theme: VideoReelsTheme });
